import { Outlet, createFileRoute } from '@tanstack/react-router';
import { SettingsNav } from 'src/features/settings/components/SettingsNav';

export const Route = createFileRoute('/_authenticated/settings')({
  head: () => ({
    meta: [{ title: 'Settings | Tekst' }],
  }),
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <div className="w-full h-full">
      <SettingsNav>
        <Outlet />
      </SettingsNav>
    </div>
  );
}
